import * as React from 'react';
import styled from 'styled-components';
import { Spinner } from '@zopauk/react-components';

const Layout = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  height: 100%;
  min-height: 400px;
`;

export default function Loading() {
  return (
    <Layout>
      <Spinner />
    </Layout>
  );
}
